import { Encryptor } from "../shared/utils"

export const EVENTS = {
	logout_user: 'logout_user',
	unsubscribeEvents: 'unsubscribe_events',
	transferEventReceived: 'transfer_event_received',
}

const CIPHER_KEYS = {
	AUTH_TOKEN: "AUTH_TOKEN",
}

Object.keys(CIPHER_KEYS).map(key => CIPHER_KEYS[key] = Encryptor.encrypt(key))

export const STORAGE_KEYS = CIPHER_KEYS
